<template>
  <el-dialog :close-on-click-modal="false"
    v-loading="loading"
    append-to-body
    custom-class="webpay"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <span slot="title">&nbsp;</span>
    <iframe
      style="width: 100%;height:700px"
      id="pay_iframe"
      name="pay_iframe"
    ></iframe>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'
import formExt from '../../core/formExt'

export default {
  name: 'pay-modal',
  props: ['visible', 'url', 'callback'],
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  data: () => ({
    loading: true
  }),
  created () {
    this.loading = true

    apiRes.get(this.url).then((res) => {
      let pageVars = res.page_vars
      if (pageVars && pageVars.vars && pageVars.form_url) {
        let fieldsToMap = ['first_name', 'last_name', 'address', 'city', 'state', 'zip', 'country']
        let toSend = {}
        let vars = pageVars.vars
        if (vars.wsb_invoice_items && vars.wsb_invoice_items.length) {
          let items = vars.wsb_invoice_items
          vars.wsb_invoice_item_name = items.map(i => i.name)
          vars.wsb_invoice_item_quantity = items.map(i => i.qty)
          vars.wsb_invoice_item_price = items.map(i => i.price)
          delete vars['wsb_invoice_items']
        }
        Object.keys(vars).forEach(k => {
          let val = vars[k] !== null && vars[k] !== undefined ? vars[k] : ''
          let fieldToMap = fieldsToMap.find(f => f === k)
          fieldToMap
            ? toSend[`wsb_ship_to_${k}`] = toSend[`wsb_${k}`] = val
            : toSend[k] = val
        })
        toSend['*scart'] = ''
        toSend['json'] = true
        toSend['wcb_cancel_return_url'] = toSend['wsb_return_url'] = location.href.replace(location.hash, '#/paycallback')

        formExt.postForm(toSend, pageVars.form_url, 'pay_iframe').then(() => { this.loading = false })
        window.onmessage = (e) => {
          if (e.data === 'payment_callback') {
            this.callback()
            this.visibleInner = false
          }
          window.onmessage = () => { }
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  }
}
</script>
